import FusionAuthClient from "@fusionauth/typescript-client";

const API_KEY: string = `${process.env.REACT_APP_API_KEY}`;
const TENANT_ID: string = `${process.env.REACT_APP_TENANT_ID}`;
const API = new FusionAuthClient(API_KEY, 'https://auth.coinprofile.co', TENANT_ID);

export default API;